export const CLIENTS_SORT_OPTIONS = [
  { value: 'parentName', label: 'Name', defaultOrder: 1 },
  { value: 'petName', label: 'Pet', defaultOrder: 1 },
];
